import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import axiosPrivate from "../../hooks/axiosPrivate";
import { showErrorToast, showSuccessToast } from "../../utils/Toaster";

const AddEditFoodCounter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [text,setText]=useState("Add")

  useEffect(() => {
    const getCounterDetails = async () => {
      try {
        if (id) {
          const res = await axiosPrivate.get(`foodCounter/${id}`);
          formik.setValues(res?.data?.data);
        }
      } catch (err) {
        showErrorToast(err.message);
      }
    };

    if (id) {
      getCounterDetails();
    }
  }, [id]);

  // Form validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required(" Food counter name is required"),
    description: Yup.string().required("Description is required "),
  });

  // Initial form values
  const initialValues = {
    name: "",
    description:"",
  };

  // Form submission handling
  const handleSubmit = async (values) => {
    try {
      if (id) {
        await axiosPrivate.post(`foodCounter/${id}`, values);
        navigate("/food-counter");
        showSuccessToast("Food Counter updated successfully");
      } else {
        await axiosPrivate.post(`foodCounter`, values);
        navigate("/food-counter");
        showSuccessToast("Food Counter added successfully");
      }
    } catch (err) {
      showErrorToast(err.message);
    }
  };

  // Formik form handling
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(()=>{
    if(id){
setText("Edit")
    }

  },[id])

  return (
    <div className='content'>
      <div
        className='section-body d-flex justify-content-center align-items-center'
        style={{ minHeight: `calc(100dvh - 106px)` }}
      >
        <div
          className='card '
          style={{ width: "30%" }}
        >
          <form onSubmit={formik.handleSubmit}>
            <div className='card-header'>
              <strong>{text} Food Counter</strong>
            </div>
            <div className='card-body'>
              <div className='row clearfix'>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Food Counter Name</label>
                    {/* Role name input */}
                    <input
                      id='name'
                      name='name'
                      type='text'
                      className='form-control'
                      placeholder='Counter Name *'
                      onChange={formik.handleChange}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                        formik.setFieldValue("name", formik.values.name.trim());
                      }}
                      value={formik.values.name}
                    />
                    {/* Display error message if there's a validation error */}
                    {formik.touched.name && formik.errors.name && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {formik.errors.name}
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-12'>
                  <div className='form-group'>
                    <label className='form-label'>Description</label>
                    {/* Role name input */}
                    <input
                      id='description'
                      name='description'
                      type='text'
                      className='form-control'
                      placeholder='Description *'
                      onChange={formik.handleChange}
                      onBlur={(e) => {
                        formik.handleBlur(e);
                        formik.setFieldValue("description", formik.values.description.trim());
                      }}
                      value={formik.values.description}
                    />
                    {/* Display error message if there's a validation error */}
                    {formik.touched.description && formik.errors.description && (
                      <div style={{ color: "red", fontSize: "12px" }}>
                        {formik.errors.description}
                      </div>
                    )}
                  </div>
                </div>
                <div className='col-12 text-right'>
                  <hr className='mt-4' />
                  {/* Close button */}
                  <button
                    type='button'
                    className='btn btn-secondary mx-1'
                    onClick={() => navigate("/food-counter")}
                  >
                    CLOSE
                  </button>
                  {/* Submit button */}
                  <button
                    type='submit'
                    className='btn btn-primary'
                  >
                    SUBMIT
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default  AddEditFoodCounter;
